import _classCallCheck from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import * as R from 'ramda';
import { DEFAULT_EE_VALUE, NutritionConstant } from 'src/constants/diet';
import { SIX_FOOD_CATEGORY, THREE_NUTRITION } from 'src/types';
import { pickSixFoodAttributes } from '../diet';
import { calcCalorieByMacros, sixGroupsToMacros } from './calculator';
var SIX_CATEGORY_TO_MACROS = NutritionConstant.SIX_CATEGORY_TO_MACROS;
export var Suggestion = /*#__PURE__*/function () {
  function Suggestion() {
    var totalCal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_EE_VALUE;
    var protein = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var fat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 25;
    var carbohydrate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 55;

    _classCallCheck(this, Suggestion);

    _defineProperty(this, "calories", void 0);

    _defineProperty(this, "protein", void 0);

    _defineProperty(this, "fat", void 0);

    _defineProperty(this, "carbohydrate", void 0);

    _defineProperty(this, "proteinWeight", 0);

    _defineProperty(this, "fatWeight", 0);

    _defineProperty(this, "carbohydrateWeight", 0);

    _defineProperty(this, "vegetables", 0);

    _defineProperty(this, "fruits", 0);

    _defineProperty(this, "milk_low_fat", 0);

    _defineProperty(this, "grains", 0);

    _defineProperty(this, "meat_beans_low_fat", 0);

    _defineProperty(this, "meat_beans_medium_fat", 0);

    _defineProperty(this, "oil", 0);

    this.calories = totalCal;
    this.protein = protein;
    this.fat = fat;
    this.carbohydrate = carbohydrate;
    this.getSuggestion();
  }

  _createClass(Suggestion, [{
    key: "getSuggestion",
    value: function getSuggestion() {
      this.getWeight();
      this.getMilkFruitsVegetables();
      this.getGrains();
      this.getMeatBeans();
      this.getOil();
    }
  }, {
    key: "getWeight",
    value: function getWeight() {
      this.proteinWeight = this.calories * this.protein / 100 / 4;
      this.fatWeight = this.calories * this.fat / 100 / 9;
      this.carbohydrateWeight = this.calories * this.carbohydrate / 100 / 4;
    }
  }, {
    key: "getMilkFruitsVegetables",
    value: function getMilkFruitsVegetables() {
      if (this.calories >= 2700) {
        var _ref = [5, 4, 2];
        this.vegetables = _ref[0];
        this.fruits = _ref[1];
        this.milk_low_fat = _ref[2];
        return;
      }

      if (this.calories >= 2500) {
        var _ref2 = [5, 4, 1.5];
        this.vegetables = _ref2[0];
        this.fruits = _ref2[1];
        this.milk_low_fat = _ref2[2];
        return;
      }

      if (this.calories >= 2200) {
        var _ref3 = [4, 3.5, 1.5];
        this.vegetables = _ref3[0];
        this.fruits = _ref3[1];
        this.milk_low_fat = _ref3[2];
        return;
      }

      if (this.calories >= 2000) {
        var _ref4 = [4, 3, 1.5];
        this.vegetables = _ref4[0];
        this.fruits = _ref4[1];
        this.milk_low_fat = _ref4[2];
        return;
      }

      var _ref5 = [3, 2, 1.5];
      this.vegetables = _ref5[0];
      this.fruits = _ref5[1];
      this.milk_low_fat = _ref5[2];
    }
  }, {
    key: "getGrains",
    value: function getGrains() {
      var grainsWeight = this.carbohydrateWeight - this.sumFromGroups(THREE_NUTRITION.carbohydrate, [SIX_FOOD_CATEGORY.vegetables, SIX_FOOD_CATEGORY.fruits, SIX_FOOD_CATEGORY.milk_low_fat]);
      this.grains = this.divideDotFive(grainsWeight / this.getIndividualWeight(SIX_FOOD_CATEGORY.grains, THREE_NUTRITION.carbohydrate));
    }
  }, {
    key: "getMeatBeans",
    value: function getMeatBeans() {
      var meatBeansProteinWeight = this.proteinWeight - this.sumFromGroups(THREE_NUTRITION.protein, [SIX_FOOD_CATEGORY.vegetables, SIX_FOOD_CATEGORY.fruits, SIX_FOOD_CATEGORY.milk_low_fat, SIX_FOOD_CATEGORY.grains]);
      this.meat_beans_low_fat = 0;
      this.meat_beans_medium_fat = 0;
      var meatBeansPortion = Math.round(meatBeansProteinWeight / 7);
      this.meat_beans_low_fat = Math.round(meatBeansPortion / 2);
      this.meat_beans_medium_fat = Math.floor(meatBeansPortion / 2);
    }
  }, {
    key: "getOil",
    value: function getOil() {
      var oilWeight = this.fatWeight - this.sumFromGroups(THREE_NUTRITION.fat, [SIX_FOOD_CATEGORY.vegetables, SIX_FOOD_CATEGORY.fruits, SIX_FOOD_CATEGORY.milk_low_fat, SIX_FOOD_CATEGORY.grains, SIX_FOOD_CATEGORY.meat_beans_low_fat, SIX_FOOD_CATEGORY.meat_beans_medium_fat]);
      this.oil = this.divideDotFive(oilWeight / this.getIndividualWeight(SIX_FOOD_CATEGORY.oil, THREE_NUTRITION.fat));
      if (this.oil < 0) this.oil = 0;

      var _sixGroupsToMacros = sixGroupsToMacros(pickSixFoodAttributes(this)),
          protein = _sixGroupsToMacros.protein,
          carbohydrate = _sixGroupsToMacros.carbohydrate,
          fat = _sixGroupsToMacros.fat;

      var calorie = calcCalorieByMacros(protein, carbohydrate, fat);
      var extraFatWeight = (this.calories - calorie) / 9;

      if (extraFatWeight > 0) {
        this.oil += this.divideDotFive(extraFatWeight / this.getIndividualWeight(SIX_FOOD_CATEGORY.oil, THREE_NUTRITION.fat));
      }
    }
  }, {
    key: "divideDotFive",
    value: function divideDotFive(numeric) {
      return 0.5 * Math.floor(numeric / 0.5);
    }
  }, {
    key: "sumFromGroups",
    value: function sumFromGroups(category, groups) {
      var _this = this;

      return R.reduce(function (total, group) {
        return R.add(total, _this[group] * SIX_CATEGORY_TO_MACROS[group][category]);
      }, 0, groups);
    }
  }, {
    key: "getIndividualWeight",
    value: function getIndividualWeight(group, category) {
      return SIX_CATEGORY_TO_MACROS[group][category];
    }
  }]);

  return Suggestion;
}();